import React, { useContext, useState, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Icon,
  Card,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal, ModalCancelamento, FontButton } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useNfeController from "../controllers/NfeController";
import { findCliente } from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { findFornecedores } from "../../../../repositories/qerpapi/erp/prouser/v1/FornecedoresRepository";
import { GlobalVariables } from "../../../../GlobalVariables";

const ModalEmailNfe = ({ modalOpen, setModalOpen, nfe, setMainLoading }) => {
  const { queryParams } = useContext(QueryParamsContext);

  const { handleSendEmail } = useNfeController();

  useEffect(() => {
    (async () => {
      setMainLoading(true);

      try {
        const groupMails = [];

        if (nfe.clifor === "C") {
          const client = await findCliente({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: nfe.idclifor,
            include: "clientescontatos",
          });

          if (!client.success) return;

          if (client.data.email && client.data.email_utilizarnfe === "S") {
            const strMail = client.data.email.replace(/\s/g, "");
            const arrMails = strMail.split(";");
            arrMails.forEach((element) => {
              if (element) {
                groupMails.push(element.toLowerCase());
              }
            });
          }

          if (client.data.clientescontatos.length) {
            client.data.clientescontatos.forEach((row) => {
              if (row.email && row.email_utilizarnfe === "S") {
                groupMails.push(row.email.toLowerCase());
              }
            });
          }
        } else {
          const provider = await findFornecedores(
            queryParams.empresa_cnpj,
            nfe.idclifor
          );

          if (provider.success && provider.data?.email1) {
            groupMails.push(provider.data.email1.toLowerCase());
          }
        }

        setEmails(groupMails);
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
    // eslint-disable-next-line
  }, [queryParams.empresa_cnpj, nfe.idclifor]);

  const handleClose = () => {
    setModalOpen(false);
  };

  const addListEmail = () => {
    if (email && email.trim()) {
      const groupMails = [...emails];
      groupMails.push(email.toLowerCase());

      setEmail("");
      setEmails(groupMails);
    }
  };

  const removeListEmail = (index) => {
    let groupMails = [...emails];
    groupMails.splice(index, 1);

    setEmails(groupMails);
  };

  const checkTypeFile = (typeId) =>
    nfe.notasfiscaisarchives.find((current) => current.types_id === typeId)
      ? typeId
      : null;

  const nfeHasCCe = checkTypeFile(GlobalVariables.NfTypeFiles.cce);
  const nfeHasReturnXml = checkTypeFile(GlobalVariables.NfTypeFiles.returnXml);
  const [xml, setXml] = useState(true);
  const [danfe, setDanfe] = useState(true);
  const [cce, setCce] = useState(true);
  const [returnXml, setReturnXml] = useState(true);
  const [crMailArchives, setCrMailArchives] = useState(false);

  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState("");

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="dialog-email-nfe"
    >
      <ModalCancelamento>
        <HeaderModal>
          <DialogTitle id="dialog-email-nfe">
            <Chip
              label="Envio de Email da NF-e"
              bgcolor="primary"
              textcolor="white"
            />
          </DialogTitle>
        </HeaderModal>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <Typography variant="subtitle2" gutterBottom>
                Selecione o que deseja ser anexado ao email:
              </Typography>
            </Grid>
            <Grid item container sm={12}>
              <Grid item>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={xml}
                      onChange={() => setXml((current) => !current)}
                      color="primary"
                    />
                  }
                  label="XML"
                  labelPlacement="start"
                />
              </Grid>
              <Grid item>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={danfe}
                      onChange={() => setDanfe((current) => !current)}
                      color="primary"
                    />
                  }
                  label="DANFE"
                  labelPlacement="start"
                />
              </Grid>
              {nfeHasCCe && (
                <Grid item>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={cce}
                        onChange={() => setCce((current) => !current)}
                        color="primary"
                      />
                    }
                    label="Carta de correção"
                    labelPlacement="start"
                  />
                </Grid>
              )}
              {nfeHasReturnXml && (
                <Grid item>
                  <FormControlLabel
                    value="end"
                    control={
                      <Switch
                        checked={returnXml}
                        onChange={() => setReturnXml((current) => !current)}
                        color="primary"
                      />
                    }
                    label="XML de retorno"
                    labelPlacement="start"
                  />
                </Grid>
              )}
              <Grid item>
                <FormControlLabel
                  value="end"
                  control={
                    <Switch
                      checked={crMailArchives}
                      onChange={() => setCrMailArchives((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Boletos Vinculados"
                  labelPlacement="start"
                />
              </Grid>
            </Grid>
            <Grid item sm={12}>
              <Typography variant="subtitle2" gutterBottom>
                Deseja adicionar mais emails?
              </Typography>
            </Grid>
            <Grid item sm>
              <TextField
                label="Email"
                size="small"
                variant="filled"
                value={email}
                setValue={setEmail}
              />
            </Grid>
            <Grid item>
              <Btn
                full="true"
                bgcolor="lightgreen"
                textcolor="white"
                hovercolor="blue"
                onClick={addListEmail}
                label={<Icon>add</Icon>}
              />
            </Grid>
            <Grid item sm={12}>
              <Card fullWidth>
                {emails.map((value, index) => (
                  <Chip
                    onDelete={() => {
                      removeListEmail(index);
                    }}
                    key={index}
                    label={value}
                    bgcolor="secondary"
                    textcolor="black"
                  />
                ))}
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <FontButton>
            <Grid container spacing={2}>
              <Grid item sm />
              <Grid item sm>
                <Btn
                  bgcolor="tertiary"
                  hovercolor="blue"
                  onClick={handleClose}
                  label="Cancelar"
                  full="true"
                />
              </Grid>
              <Grid item sm>
                <Btn
                  label="Enviar Email"
                  full="true"
                  onClick={() => {
                    handleSendEmail(
                      nfe.id,
                      setMainLoading,
                      emails,
                      [
                        xml ? GlobalVariables.NfTypeFiles.xml : null,
                        danfe ? GlobalVariables.NfTypeFiles.danfe : null,
                        nfeHasCCe != null && cce ? nfeHasCCe : null,
                        nfeHasReturnXml != null && returnXml
                          ? nfeHasReturnXml
                          : null,
                      ].filter((current) => current !== null),
                      crMailArchives,
                      setModalOpen
                    );
                  }}
                />
              </Grid>
            </Grid>
          </FontButton>
        </DialogActions>
      </ModalCancelamento>
    </Dialog>
  );
};

export default ModalEmailNfe;
